import React from "react";
import { letterAvatarX } from "../../helpers/latter-avatar";

export const Avatar = ({ name, size, color, fullText, singleLetterAvatar, ...props }) => (<img
    {...props.id ? { id: props.id } : {}}
    {...props.onClick ? { onClick: props.onClick } : {}}
    {...props.style ? { style: props.style } : {}}
    className={`avatar ${props.className || ''}`}
    title={props.title ? props.title : ((props.autoTitle === true || typeof props.autoTitle === "undefined") ? name : "")}
    src={props.src ? props.src : letterAvatarX({ name, size, color, fullText, singleLetterAvatar })} alt={props.name} />);
